export const ParisColor = '#BC9B67';
export const MedicalColor = '#3A8EBA  ';
export const ServiceColor = '#098721';
export const AdminColor = "#222"